import React from 'react'
import ProgressBarChart from './ProgressBarChart';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import Loader from '../../../common/Loader';
import { determineCommaSeprater,formatHoursOff, FormatInvoiceDecimalNumber, getValueFromResource } from '../../../common/timeLiveFunction'
import { t } from "i18next";

const SummaryBoxes = (props: any) => {
    const { projectSummary, projectSummaryData } = props;
    const { isLoading } = useAppSelector((state) => state.tasks);
    const { cultureInfoName, decimalPlaces,decimalFormat} = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const isComma = determineCommaSeprater(cultureInfoName.toString());
    const TimeEntryHours = projectSummaryData?.TimeEntryHours || {};
    const ExpenseHours = projectSummaryData?.ExpenseHours || {};

    const timeToDecimal = (timeStr: any) => {
        if (!timeStr || typeof timeStr !== 'string') return 0;
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours + minutes / 60;
    };

    return (
        <>
            {/* {isLoading && <Loader />} */}
            <div className="row">
                <div className="col-12 col-lg-6 mb-4">
                    <div
                        className="card rounded-3 h-100"
                        style={{
                            border: '1px solid #dee2e6',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        }}
                    >
                        <div className="px-4 pb-4">
                            <div className="d-flex justify-content-between align-items-start">
                                <h3 className="headerTitle">
                                    {getValueFromResource('Hours Summary', dispatch, t)}
                                    {/* Hours Summary */}
                                </h3>
                            </div>

                            <div className="">
                                <p className="text-muted small" style={{ lineHeight: 1 }}>
                                    {getValueFromResource('Total Hours', dispatch, t)}
                                    {/* Total Hours */}
                                </p>
                                <span className="fw-bold fs-1" style={{ color: '#181c32' }}>{ projectSummary.totalHours}</span>
                            </div>

                            <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="flex-fill">
                                        <p className="text-muted small" style={{ lineHeight: 1 }}>
                                            {getValueFromResource('Billable Hours', dispatch, t)}
                                            {/* Billable Hours */}
                                        </p>
                                        <span className="fw-bold fs-3" style={{ color: '#181c32' }}>{ projectSummary.billableHours}</span>
                                    </div>
                                    <div className="text-center px-3 position-relative d-flex flex-column align-items-center">
                                        <div
                                            style={{
                                                width: '2px',
                                                height: '20px',
                                                backgroundColor: '#ccc',
                                            }}
                                        ></div>
                                        <div
                                            style={{
                                                backgroundColor: '#f0f0f0',
                                                borderRadius: '50%',
                                                width: '40px',
                                                height: '40px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                            }}
                                        >
                                            vs
                                        </div>
                                        <div
                                            style={{
                                                width: '2px',
                                                height: '20px',
                                                backgroundColor: '#ccc',
                                            }}
                                        ></div>
                                    </div>

                                    <div className="flex-fill text-end">
                                        <p className="text-muted small" style={{ lineHeight: 1 }}>
                                            {getValueFromResource('Non-Billable Hours', dispatch, t)}
                                            {/* Non-Billable Hours */}
                                        </p>
                                        <span className="fw-bold fs-3" style={{ color: '#181c32' }}>{projectSummary.nonBillableHours}</span>
                                    </div>
                                </div>
                                <ProgressBarChart
                                    billablePercent={
                                        (timeToDecimal(TimeEntryHours?.ConvertBillableTotalMinutes) / timeToDecimal(TimeEntryHours?.ConvertTotalMinutes)) * 100
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-6 mb-4">
                    <div
                        className="card rounded-4 h-100"
                        style={{
                            border: '1px solid #dee2e6',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        }}
                    >
                        <div className="px-4 pb-4">
                            <div className="d-flex justify-content-between align-items-start">
                                <h3 className="headerTitle">
                                    {getValueFromResource('Expense Summary', dispatch, t)}
                                    {/* Expense Summary */}
                                </h3>
                            </div>

                            <div className="">
                                <p className="text-muted small" style={{ lineHeight: 1 }}>
                                    {getValueFromResource('Total Expense', dispatch, t)}
                                    {/* Total Expense */}
                                </p>
                                <span className="fw-bold fs-1" style={{ color: '#181c32' }}>
{/*                                     {Number(projectSummary.totalExpense).toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })} */}
                                    {projectSummary.totalExpense}
                                </span>

                            </div>

                            <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="flex-fill">
                                        <p className="text-muted small" style={{ lineHeight: 1 }}>
                                            {getValueFromResource('Billable Expense', dispatch, t)}
                                            {/* Billable Expense */}
                                        </p>
                                        <span className="fw-bold fs-3" style={{ color: '#181c32' }}>
                                            {projectSummary.billableExpense}
                                            {/* {FormatInvoiceDecimalNumber(cultureInfoName.toString(), projectSummary.billableExpense, decimalPlaces)} */}
                                        </span>

                                    </div>
                                    <div className="text-center px-3 position-relative d-flex flex-column align-items-center">
                                        <div
                                            style={{
                                                width: '2px',
                                                height: '20px',
                                                backgroundColor: '#ccc',
                                            }}
                                        ></div>
                                        <div
                                            style={{
                                                backgroundColor: '#f0f0f0',
                                                borderRadius: '50%',
                                                width: '40px',
                                                height: '40px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                            }}
                                        >
                                            vs
                                        </div>
                                        <div
                                            style={{
                                                width: '2px',
                                                height: '20px',
                                                backgroundColor: '#ccc',
                                            }}
                                        ></div>
                                    </div>

                                    <div className="flex-fill text-end">
                                        <p className="text-muted small" style={{ lineHeight: 1 }}>
                                            {getValueFromResource('Non-Billable Expense', dispatch, t)}
                                            {/* Non-Billable Expense */}
                                        </p>
                                        <span className="fw-bold fs-3" style={{ color: '#181c32' }}>
{/*                                             {Number(projectSummary.nonBillableExpense).toLocaleString('en-US', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })} */}
                                            {projectSummary.nonBillableExpense}
                                        </span>
                                    </div>
                                </div>

                                <ProgressBarChart billablePercent={((ExpenseHours.billableamount) / Number(ExpenseHours.Amount)) * 100} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SummaryBoxes;